export default __webpack_public_path__ + "static/media/da_app_honu_64.bbdd0404.ico";